import { AgGridReact } from 'ag-grid-react';
import { RefObject } from 'react';
import { GuardedColDef, TableActions, TableSettings } from '../types';
import { useAgGridTabbing } from './useAgGridTabbing';
import { useAgTableColumnResize } from './useAgTableColumnResize';
import { useTableFilters } from './useTableFilters';
import { useTableSorting } from './useTableSorting';

export type TableProps<T> = {
    tableSettings: TableSettings;
    tableActions: TableActions;
    columns: GuardedColDef<T>[];
    rows: T[];
    gridRef: RefObject<AgGridReact>;
};

export const useAgTable = <T>({ tableSettings, tableActions, columns, rows, gridRef }: TableProps<T>) => {
    const filterState = useTableFilters(tableSettings.filters, tableActions.filtersChanged);
    const tableSorting = useTableSorting(tableSettings.sorting, tableActions.sortingChanged);
    const { resizableColumns, saveColumnWidth } = useAgTableColumnResize(
        columns,
        tableSettings.columns,
        tableActions.columnsResized
    );
    // const draggableColumns = useAgDraggableColumns(resizableColumns, tableActions.columnsReordered);
    const tabbing = useAgGridTabbing(
        gridRef?.current?.columnApi?.getAllDisplayedColumns() ?? [],
        rows,
        gridRef
    );

    return {
        filterState,
        tableSorting,
        resizableColumns,
        columns,
        saveColumnWidth,
        tabbing
    };
};
